import { Box, Button, Card, CardActionArea, CircularProgress, Divider, Grid, Typography } from "@mui/material"
import React from "react"
import IndexDispatch from "./model"
import ServicesState from "../../State/ServicesState"
import AutoSizer from "react-virtualized-auto-sizer"
import InfoUI from "../../../Info/UI/Browser/Info";

class Index extends React.PureComponent<{}>{
    componentDidMount(): void {
        let dispatcher: IndexDispatch = (this.props as any).dispatcher
        dispatcher.fetch()
    }
    render() {
        let state: ServicesState = (this.props as any).state
        let dispatcher: IndexDispatch = (this.props as any).dispatcher

        let html: JSX.Element

        if (state.loading) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <CircularProgress />
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }}>
                    در حال دریافت اطلاعات
                </Typography>
            </Box>
        } else if (state.data && state.data.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات یافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetch()
                }}>تلاش مجدد</Button>
            </Box>
        } else if (state.error) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات دریافت نشد
                </Typography>
                <Button variant="contained" color='error' size='small' onClick={() => {
                    dispatcher.fetch()
                }}>تلاش مجدد</Button>
            </Box>
        } else {

            let qs = new URLSearchParams(window.location.search)
            const id = qs.get('id');

            if(id !== null){
                let item = state.data.find((value , index , arr) => {
                    return value.id === +id
                })

                window.history.replaceState(null, '', window.location.pathname)
                dispatcher.selected(item)
            }

            html = <Box sx={{ pr: 0.5, pl: 0.5, pt: 2, pb: 2, overflowY: 'auto' }}>

                <Grid container spacing={{ xs: 1, md: 3 }} columns={{ xs: 1, sm: 1, md: 1 }}>
                    {state.data.map((_, index) => {

                        let value = state.data[index]                        

                        return (
                            <Grid item xs={1} sm={1} md={1} key={index}>
                                <Card key={index} variant="elevation" sx={{ height : '100%' , width: '100%', borderRadius: '12px', borderColor: 'transparent', bgcolor: '#f5f5f5', p: 1 }} >
                                    <CardActionArea sx={{ width: '100%', height: '100%', flexDirection: 'column' }} onClick={() => {                                        
                                        dispatcher.selected(value)
                                    }}>

                                        <AutoSizer disableHeight style={{ width: '100%' }}>
                                            {({ width }: any) => {
                                                return (

                                                    <Box
                                                        component="img"
                                                        sx={{
                                                            height: '100px',
                                                            width: width
                                                        }}
                                                        alt='services'
                                                        src={value.icon}
                                                        crossOrigin='anonymous'
                                                    />
                                                )
                                            }
                                            }
                                        </AutoSizer>

                                        <Box sx={{ width: '100%', flexDirection: 'row', mt: 2 }} display='flex'>

                                            <Box sx={{ flexGrow: 1, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                    {value.title}
                                                </Typography>
                                            </Box>

                                        </Box>
                                    </CardActionArea>

                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>

            </Box>
        }

        return (<Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ flexDirection: 'row' }} display="flex"
                justifyContent="start"
                alignItems="center">
                <Typography fontWeight='fontWeightBold' variant="h6" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                    خدمات فایل چرخ
                </Typography>
            </Box>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ mt: 1 }} />
            <Box sx={{ height: '100%', width: '100%', flexDirection: 'column', mt: 2 }} display="contents"
                justifyContent="center"
                alignItems="center">
                <Card variant="elevation" sx={{ height: '100%', borderRadius: '12px', borderColor: 'transparent', p: 2, mr: 1, ml: 1, mt: 1 }} >
                    <Box sx={{ flexDirection: 'column', height: '100%' }} display="flex">

                        {html}
                    </Box>
                </Card>
            </Box>
            <InfoUI service={state.selected} onClose={() => {
                dispatcher.selected(undefined)
            }} />
        </Box>)
    }
}

export default Index